import Header from "./Components/header";
import Home from "./Page/Home"
import "./App.css"
import { Routes, Route } from 'react-router-dom';
import Events from "./Page/Events";
import EventDetails from "./Page/EventDetails";
import Register from "./Page/Register";
import Ticket from "./Page/Ticket";
import AboutUs from "./Page/AboutUs";

function App() {
  return (
    <div className="App">
      <nav>
        <Header />
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<EventDetails />} />
        <Route path="/register" element={<Register />} />
        <Route path="/ticket" element={<Ticket />} />
        <Route path="/aboutUs" element={<AboutUs />} />
      </Routes>
    </div>
  );
}

export default App;
